"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchBoxComponent = void 0;
const core_1 = require("@angular/core");
let SearchBoxComponent = class SearchBoxComponent {
    constructor() {
        this.update = new core_1.EventEmitter();
    }
    ngOnInit() {
        this.update.emit('');
    }
};
exports.SearchBoxComponent = SearchBoxComponent;
__decorate([
    (0, core_1.Output)(),
    __metadata("design:type", Object)
], SearchBoxComponent.prototype, "update", void 0);
exports.SearchBoxComponent = SearchBoxComponent = __decorate([
    (0, core_1.Component)({
        selector: 'search-box',
        template: '<div class="input-group ourSearchBox">' +
            ' <span class="input-group-addon">' +
            '   <i class="fa fa-search"></i>' +
            ' </span>' +
            ' <input #input type="text" (input)="update.emit(input.value)">' +
            '</div>'
    })
], SearchBoxComponent);
//# sourceMappingURL=search-box.component.js.map